export const styles = {
  error: {
    color: "#d32f2f",
    fontSize: "11px",
    position: "absolute",
    top: "60px",
    userSelect: "none",
  },
  dialog: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  container: {
    width: "380px",
    bgcolor: "#fff",
    boxShadow: 24,
    p: "1rem 0",
  },
  formBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  phone: {
    height: "56px",
    width: "100%",
    background: "transparent",
  },
};
